module.exports = __webpack_public_path__ + "static/media/finance-debt-to-capital.b7974f87.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/finance-debt-to-capital.mp4
// module id = 1059
// module chunks = 0